<template>
  <div class="match-success-page">
    <img
      class="top-bg__image"
      src="../../public/img/common/top_bg.png"
      alt=""
    />
    <div class="page-content">
      <div class="success-header">
        <img
          class="success-header__icon"
          src="../../public/img/register/register_tl12/check_icon.png"
          alt=""
        />
        <div class="success-header__text">
          <span class="success-header__title">审核通过!</span>
          <span class="success-header__desc"
            >系统已经为您匹配到优质的借款机构</span
          >
        </div>
      </div>

      <div class="success-loan-card">
        <img
          class="success-loan-card__bg"
          src="../../public/img/register/register_tl12/form_card_bg.png"
          alt=""
        />
        <div class="success-loan-card__body">
          <div class="success-loan-card__amount-row">
            <span class="success-loan-card__amount">{{ estimatedAmount }}</span>
            <span class="success-loan-card__label">预估可借额度(元)</span>
          </div>
          <div class="success-loan-card__features">
            <div class="success-loan-card__feature">
              <img
                class="success-loan-card__feature-icon"
                src="../../public/img/register/register_tl12/money_icon.png"
                alt=""
              />
              <span class="success-loan-card__feature-text">灵活借还</span>
            </div>
            <div class="success-loan-card__feature">
              <img
                class="success-loan-card__feature-icon"
                src="../../public/img/register/register_tl12/blue_safe_icon.png"
                alt=""
              />
              <span class="success-loan-card__feature-text">安全保障</span>
            </div>
            <div class="success-loan-card__feature">
              <img
                class="success-loan-card__feature-icon"
                src="../../public/img/register/register_tl12/diamond_icon.png"
                alt=""
              />
              <span class="success-loan-card__feature-text">优质服务</span>
            </div>
          </div>
        </div>
      </div>

      <div class="success-info-card">
        <div class="success-info-row">
          <span class="success-info-row__label">贷款服务平台</span>
          <span class="success-info-row__value">{{ platformName }}</span>
        </div>
        <div class="success-info-row">
          <span class="success-info-row__label">贷款服务公司</span>
          <span class="success-info-row__value">{{ companyName }}</span>
        </div>
        <div class="success-info-row success-info-row--last">
          <span class="success-info-row__label">贷款服务产品</span>
          <span class="success-info-row__value">{{ productName }}</span>
        </div>
      </div>

      <div class="success-agree-card">
        <p class="success-agree-card__notice">
          特别提示：分享借平台会根据您的资质，匹配专业的贷款咨询服务机构，请咨询阅读以下协议
        </p>
        <div
          v-if="agreements.length"
          ref="agreeTabs"
          class="success-agree-card__tabs"
        >
          <span
            v-for="item in agreements"
            :key="item.id"
            :id="'tab-' + item.id"
            class="success-agree-card__tab"
            :class="{
              'success-agree-card__tab--active': activeAgreementId === item.id,
            }"
            @click="onAgreementTap(item.id)"
            >《{{ item.contractName }}》</span
          >
        </div>
        <div
          ref="agreeScroll"
          class="success-agree-card__scroll"
          @scroll="onAgreementScroll"
        >
          <div
            v-for="item in agreements"
            :key="item.id"
            :id="item.id"
            class="success-agree-card__block protocol-content"
          >
            <div
              v-if="item.contractContent"
              v-html="item.contractContent"
            ></div>
            <span v-else class="success-agree-card__empty">暂无协议内容</span>
          </div>
          <span v-if="!agreements.length" class="success-agree-card__empty"
            >暂无协议内容</span
          >
        </div>
      </div>

      <div
        class="success-btn"
        :class="{ 'success-btn--disabled': loading }"
        @click="handleGoOn"
      >
        {{ loading ? "提交中..." : "同意协议，领取额度" }}
      </div>
    </div>

    <!-- 退出阻断弹窗 -->
    <van-popup
      v-model="returnShow"
      :close-on-click-overlay="false"
      :style="{
        width: '80%',
        height: 'auto',
      }"
      round
    >
      <div class="return-con u-text-center">
        <h3>
          距离<span>{{ form.loanAmount }}</span
          >元额度
        </h3>
        <h1>仅剩1步</h1>
        <p class="return-con-tips">确定要离开吗？</p>
        <van-button
          class="return-con-btn"
          block
          color="#678CF9"
          round
          @click="returnShow = false"
        >
          继续填写
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
/**
 * 匹配成功页（对齐小程序 pages/match-success）
 *
 * 入参（query）：orderSn、applyId —— 用于请求 matchResultV2
 * 展示数据：companyName / productName / contract 等均来自 matchResultV2
 * 同意协议：按钮调用 mixin.handleGoOn → submitPushApply
 *   1. 有 redirectUrl → 打开三方页
 *   2. 无 redirectUrl → pushApply 后再 gotoNextPage
 */
import * as API_Common from "@/api/common.js";
import { applyBus } from "@/mixins/applyBusEntry.js";

const PLATFORM_NAME = "分享借";

/**
 * 从 matchResultV2.contract 组装协议列表
 * 顺序：defaultContract 置首，再追加 contracts（同名去重）
 */
function buildAgreements(contract) {
  const list = [];
  const defaultContract = contract?.defaultContract;
  if (defaultContract) list.push(defaultContract);

  (contract?.contracts || []).forEach((item) => {
    if (
      defaultContract?.contractName &&
      item?.contractName === defaultContract.contractName
    ) {
      return;
    }
    list.push(item);
  });

  return list
    .filter((item) => item?.contractName)
    .map((item, index) => ({
      id: `agreement-${index}`,
      contractName: item.contractName,
      contractContent: item.contractContent || "",
    }));
}

/** 预估额度展示格式化 */
function formatAmount(value) {
  const amount = Number(String(value || "").replace(/,/g, "")) || 0;
  return amount ? amount.toLocaleString("en-US") : "50,000";
}

export default {
  name: "MatchSuccess",
  mixins: [applyBus],
  data() {
    const query = this.$route.query;
    return {
      platformName: PLATFORM_NAME,
      estimatedAmount: formatAmount(query.amount), // 预估可借额度（来自进件页 query.amount）
      companyName: "--", // 贷款服务公司，来自 matchResultV2
      productName: "--", // 贷款服务产品，来自 matchResultV2
      agreements: [], // 协议列表，来自 matchResultV2.contract
      activeAgreementId: "", // 当前高亮的协议 tab
      loading: false, // 同意协议按钮 loading（submitPushApply 共用）
      applyId: Number(query.applyId) || 0,
      productId: null, // pushApply 入参，来自 matchResultV2
      redirectUrl: "", // 有值则同意后直接跳三方，不再调 pushApply
      hasPushSuccess: 1,
      brand: query.brand,
      downPageUrl: query.downPageUrl,
      isRedirectProductsPage: parseInt(query.isRedirectProductsPage) || 0,
      isRedirectWorkWeixinPage: parseInt(query.isRedirectWorkWeixinPage) || 0,
      form: {
        channelNo: query.source,
        loanAmount: query.amount || 0,
        reqId: query.reqId,
      },
      returnShow: false, // 退出阻断弹窗状态
    };
  },
  watch: {
    // 弹框显示时 pushState，供返回键使用
    returnShow(newVal) {
      if (newVal === true) {
        window.history.pushState(null, null, document.URL);
      }
    },
  },
  mounted() {
    const orderSn = this.$route.query.orderSn || "";
    if (!orderSn || !this.applyId) {
      this.$toast("页面参数异常");
      setTimeout(() => this.$router.back(), 1500);
      return;
    }
    this.addHistory();
    this.loadMatchResult(orderSn, this.applyId);
  },
  beforeDestroy() {
    if (this.scrollSyncTimer) {
      clearTimeout(this.scrollSyncTimer);
      this.scrollSyncTimer = null;
    }
    window.removeEventListener("popstate", this.openReturnPop, false);
  },
  methods: {
    // 给浏览器的访问记录添加一条此页面的访问记录
    addHistory() {
      window.history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.openReturnPop, false);
    },

    // 打开回退弹窗
    openReturnPop() {
      this.returnShow = true;
      if (/(Android)/i.test(navigator.userAgent)) {
        try {
          // 安卓直接使用 popstate 监听返回键无效，需要加这行代码
          window.tbs_bridge.nativeExec("network", "type", 0, null);
        } catch (e) {
          console.log(e);
        }
      }
    },

    /**
     * 请求 matchResultV2，填充页面并缓存推送参数（applyId / productId / redirectUrl）
     * 接口失败或缺少 productId 时返回上一页
     */
    async loadMatchResult(orderSn, applyId) {
      try {
        const res = await API_Common.matchResultV2({ orderSn, applyId });
        if (res?.code !== 200 || !res.data?.productId) {
          this.$toast(res?.msg || "获取匹配结果失败");
          setTimeout(() => {
            window.removeEventListener("popstate", this.openReturnPop, false);
            this.$router.back();
          }, 1500);
          return;
        }

        const data = res.data;
        this.applyId = data.applyId || applyId;
        this.productId = data.productId;
        this.redirectUrl = data.redirectUrl || "";
        this.companyName = data.companyName || "--";
        this.productName = data.productName || "--";

        const agreements = buildAgreements(data.contract);
        this.agreements = agreements;
        this.activeAgreementId = agreements[0]?.id || "";
      } catch (error) {
        this.$toast("获取匹配结果失败");
        setTimeout(() => {
          window.removeEventListener("popstate", this.openReturnPop, false);
          this.$router.back();
        }, 1500);
      }
    },

    /** 切换协议 tab，滚动到对应协议内容，并短暂忽略滚动同步避免高亮闪烁 */
    onAgreementTap(id) {
      if (!id || id === this.activeAgreementId) return;

      this.ignoreScrollSyncUntil = Date.now() + 400;
      this.activeAgreementId = id;
      this.scrollActiveTabIntoView(id);

      this.$nextTick(() => {
        const scroller = this.$refs.agreeScroll;
        const el = scroller && document.getElementById(id);
        if (!el || !scroller) return;

        const delta =
          el.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
        scroller.scrollTop += delta;
      });
    },

    /** 协议内容滚动时，同步上方协议名下划线 */
    onAgreementScroll() {
      if (Date.now() < this.ignoreScrollSyncUntil) return;

      if (this.scrollSyncTimer) {
        clearTimeout(this.scrollSyncTimer);
      }
      this.scrollSyncTimer = setTimeout(() => {
        this.syncActiveAgreementByScroll();
      }, 60);
    },

    /**
     * 根据当前滚动位置高亮对应协议 tab
     * 取「顶部已越过容器上沿附近」的最后一个协议块为当前协议
     */
    syncActiveAgreementByScroll() {
      const scroller = this.$refs.agreeScroll;
      if (!scroller || !this.agreements.length) return;

      const blocks = scroller.querySelectorAll(".success-agree-card__block");
      if (!blocks.length) return;

      const topLine = scroller.getBoundingClientRect().top + 24;
      let nextId = this.agreements[0].id;

      blocks.forEach((block, index) => {
        if (block.getBoundingClientRect().top <= topLine) {
          nextId = this.agreements[index]?.id || nextId;
        }
      });

      if (!nextId || nextId === this.activeAgreementId) return;

      this.activeAgreementId = nextId;
      this.scrollActiveTabIntoView(nextId);
    },

    /** 横向滚动协议名，保证当前 tab 可见 */
    scrollActiveTabIntoView(id) {
      const tab = document.getElementById(`tab-${id}`);
      if (tab && typeof tab.scrollIntoView === "function") {
        tab.scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
          block: "nearest",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.match-success-page {
  position: relative;
  min-height: 100vh;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.top-bg__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  pointer-events: none;
}

.page-content {
  position: relative;
  z-index: 1;
  padding: 0.5rem 0.32rem 0.48rem;
  box-sizing: border-box;
}

.success-header {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  margin-bottom: 0.32rem;
}

.success-header__icon {
  width: 0.68rem;
  height: 0.68rem;
  flex-shrink: 0;
}

.success-header__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
}

.success-header__title {
  font-size: 0.32rem;
  color: #678cf9;
  font-weight: 500;
}

.success-header__desc {
  font-size: 0.28rem;
  color: #202020;
}

.success-loan-card {
  position: relative;
  width: 100%;
  height: 2.2rem;
  margin: 0 auto 0.24rem;
  border-radius: 0.24rem;
  overflow: hidden;
}

.success-loan-card__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.success-loan-card__body {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 0.4rem 0.5rem 0.3rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.success-loan-card__amount-row {
  display: flex;
  align-items: baseline;
  gap: 0.16rem;
}

.success-loan-card__amount {
  line-height: 1;
  font-size: 0.68rem;
  color: #fff;
}

.success-loan-card__label {
  font-size: 0.24rem;
  color: #fff;
  opacity: 0.85;
}

.success-loan-card__features {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.success-loan-card__feature {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.08rem;
}

.success-loan-card__feature-icon {
  width: 0.4rem;
  height: 0.4rem;
  flex-shrink: 0;
}

.success-loan-card__feature-text {
  font-size: 0.24rem;
  color: #fff;
  white-space: nowrap;
}

.success-info-card {
  background: #fff;
  border-radius: 0.16rem;
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.04);
  padding: 0.08rem 0.32rem;
  margin-bottom: 0.24rem;
}

.success-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 0.88rem;
  gap: 0.24rem;
}

.success-info-row__label {
  flex-shrink: 0;
  font-size: 0.28rem;
  color: #202020;
}

.success-info-row__value {
  flex: 1;
  text-align: right;
  font-size: 0.28rem;
  color: #999;
}

.success-agree-card {
  background: #fff;
  border-radius: 0.16rem;
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.04);
  padding: 0.32rem;
  margin-bottom: 0.32rem;
}

.success-agree-card__notice {
  font-size: 0.24rem;
  color: #202020;
  line-height: 1.6;
  margin-bottom: 0.16rem;
}

.success-agree-card__tabs {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 0.24rem;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.success-agree-card__tab {
  flex-shrink: 0;
  font-size: 0.24rem;
  line-height: 1.5;
  color: #678cf9;
  padding-bottom: 0.06rem;
  border-bottom: 0.04rem solid transparent;
  cursor: pointer;
}

.success-agree-card__tab--active {
  font-weight: 500;
  border-bottom-color: #678cf9;
}

.success-agree-card__scroll {
  height: 3.76rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f5f5f5;
  border-radius: 0.16rem;
  padding: 0.24rem;
  box-sizing: border-box;
}

.success-agree-card__block {
  margin-bottom: 0.32rem;
  font-size: 0.26rem;
  color: #666;
  line-height: 1.6;
}

.success-agree-card__block:last-child {
  margin-bottom: 0;
}

.success-agree-card__empty {
  font-size: 0.24rem;
  color: #999;
}

.success-btn {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.5rem;
  background: #678cf9;
  color: #fff;
  font-size: 0.32rem;
  text-align: center;
  cursor: pointer;
}

.success-btn--disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* 对齐 registerEntry return-con */
.return-con {
  padding: 0.8rem 0.36rem 0.6rem;
  font-size: 0.36rem;
  font-family: PingFangSC, PingFangSC-Medium;
  color: #111c31;
  text-align: center;
}

.return-con > h3 {
  font-weight: normal;
}

.return-con > h3 > span {
  color: #678cf9;
}

.return-con > h1 {
  font-size: 0.94rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: normal;
  color: #678cf9;
  margin-bottom: 0.24rem;
}

.return-con-tips {
  font-size: 0.28rem;
  font-weight: normal;
  font-family: PingFangSC, PingFangSC-Regular;
  color: #868e9e;
}

.return-con-btn {
  margin: 0.36rem 0 0.3rem;
}
</style>
